import React from 'react';
import { Linkedin, Facebook, Instagram, Mail, Phone, Send, ShieldCheck } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const linkClasses = "text-slate-300 hover:text-white transition-colors";

  return (
    <footer className="relative bg-slate-950 text-white pt-14 pb-10 overflow-hidden">
      <div className="absolute inset-0 opacity-40 bg-[radial-gradient(circle_at_15%_15%,rgba(79,195,247,0.18)_0,transparent_28%),radial-gradient(circle_at_85%_0,rgba(0,137,123,0.2)_0,transparent_30%)]" />
      <div className="container mx-auto px-6 relative">
        <div className="grid grid-cols-1 lg:grid-cols-[1.3fr_1fr] gap-8 items-center p-6 rounded-3xl border border-white/10 bg-white/5 backdrop-blur">
          <div className="space-y-3">
            <p className="text-xs uppercase tracking-[0.3em] text-white/60">Vamos conversar</p>
            <h3 className="text-2xl sm:text-3xl font-bold">Pronto para acelerar sua operação?</h3>
            <p className="text-slate-300 max-w-xl">
              Agende uma demonstração e veja como o ecossistema Zartoo integra vendas, entregas e inteligência em um só fluxo.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 lg:justify-end">
            <a href="/demonstracao" className="px-6 py-3 rounded-xl bg-white text-slate-900 font-semibold hover:bg-slate-100 transition-colors">
              Agendar demonstração
            </a>
            <a href="/contato" className="px-6 py-3 rounded-xl border border-white/30 font-semibold hover:bg-white/10 transition-colors">
              Falar com consultor
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mt-12">
          <div className="space-y-4 md:col-span-2">
            <div className="flex items-center gap-3">
              <img
                src="https://zartoo.s3.sa-east-1.amazonaws.com/zartoo-logo-branca.png"
                alt="Zartoo"
                className="h-10"
              />
              <div className="text-xs uppercase tracking-[0.2em] text-white/60">
                Tecnologia em Software
              </div>
            </div>
            <p className="text-slate-300 max-w-xl">
              Transforme desafios de gestão em conquistas de eficiência com o ecossistema WiBi ERP, WiBi PDV e Zartoo APP. Dados online, segurança e inteligência em cada operação.
            </p>
            <div className="flex gap-3 text-gray-300">
              <a href="https://linkedin.com/company/zartoo-tecnologia-em-software" target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg bg-white/5 hover:bg-white/10">
                <Linkedin size={18} />
              </a>
              <a href="https://facebook.com/zartoobrasil" target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg bg-white/5 hover:bg-white/10">
                <Facebook size={18} />
              </a>
              <a href="https://instagram.com/zartoo.br" target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg bg-white/5 hover:bg-white/10">
                <Instagram size={18} />
              </a>
            </div>
          </div>

          <div className="space-y-3">
            <h4 className="text-base font-semibold text-white/90">Produtos</h4>
            <a href="/sistema-erp" className={linkClasses}>WiBi ERP</a>
            <a href="/sistema-pdv" className={linkClasses}>WiBi PDV</a>
            <a href="/app-vendas" className={linkClasses}>Zartoo APP</a>
            <a href="/sistema-erp" className={linkClasses}>Integrações</a>
          </div>

          <div className="space-y-3">
            <h4 className="text-base font-semibold text-white/90">Recursos</h4>
            <a href="/sistema-erp" className={linkClasses}>Compras</a>
            <a href="/sistema-erp" className={linkClasses}>Vendas</a>
            <a href="/sistema-erp" className={linkClasses}>Estoque</a>
            <a href="/sistema-erp" className={linkClasses}>Finanças</a>
            <a href="/faq" className={linkClasses}>FAQ</a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
          <div className="flex items-start gap-3 p-5 rounded-2xl border border-white/10 bg-white/5">
            <Phone className="w-5 h-5 text-zartoo-light mt-1" />
            <div>
              <p className="text-slate-300 text-sm">WhatsApp</p>
              <p className="font-semibold">(11) 97559-2019 / (11) 99861-0036</p>
            </div>
          </div>
          <div className="flex items-start gap-3 p-5 rounded-2xl border border-white/10 bg-white/5">
            <Mail className="w-5 h-5 text-zartoo-light mt-1" />
            <div>
              <p className="text-slate-300 text-sm">E-mail</p>
              <p className="font-semibold">contato@zartoo.com.br</p>
            </div>
          </div>
          <div className="flex items-start gap-3 p-5 rounded-2xl border border-white/10 bg-white/5">
            <ShieldCheck className="w-5 h-5 text-zartoo-light mt-1" />
            <div>
              <p className="text-slate-300 text-sm">Horário</p>
              <p className="font-semibold">Seg a Sex: 8h às 18h</p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-slate-400">
          <p>© {currentYear} Zartoo Tecnologia em Software. Todos os direitos reservados.</p>
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-2">
              <Send className="w-4 h-4" />
              Desenvolvido com 💚
            </span>
            <span className="hidden md:inline">•</span>
            <a href="/privacidade" className={linkClasses}>Política de Privacidade</a>
            <a href="/termos" className={linkClasses}>Termos de Uso</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
